import script from "./copyRight.vue?vue&type=script&setup=true&lang=js"
export * from "./copyRight.vue?vue&type=script&setup=true&lang=js"

import "./copyRight.vue?vue&type=style&index=0&id=3bfc326b&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfc326b"]])

export default __exports__